import { render, staticRenderFns } from "./userset_date.vue?vue&type=template&id=22ac7c36"
import script from "./userset_date.vue?vue&type=script&lang=js"
export * from "./userset_date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports